import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/index.css';
import './Styles/App.css'
import './Styles/dsc.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap/dist/js/bootstrap.min.js";
import { Provider } from 'react-redux';
import { store } from './Reducers/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Provider store={store}>
  <App />
  </Provider>

</React.StrictMode>
);
reportWebVitals();
